/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`En Svelte solo es necesario que declares la ruta del archivo que necesitas`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-unknown"
      }}><code parentName="pre" {...{
          "className": "language-unknown"
        }}>{`&lt;img
  src=&#39;img/error.gif&#39;
  alt=&quot;Hubo un error buscando tu pokemon&quot;
  class=&quot;pokedex-no-screen&quot;
/&gt;`}</code></pre></div>
    <p>{`Sin embargo no es una ruta relativa. En Svelte, siempre debes de colocar tus archivos estáticos dentro del directorio `}<em parentName="p">{`public`}</em>{` y declarar la ruta a seguir dentro de esta carpeta.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;